import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreState } from '@store/reducers';

export const selectStoreState = createFeatureSelector<StoreState>('store');

export const selectStoreLoading = createSelector(
  selectStoreState,
  (state) => state.loading
);

export const selectStoreList = createSelector(
  selectStoreState,
  (state) => state.storeList
);

export const selectStoreError = createSelector(
  selectStoreState,
  (state) => state.error
);

export const selectStoreEditMode = createSelector(
  selectStoreState,
  (state) => state.editMode
);

export const selectStoreIsEditing = createSelector(
  selectStoreState,
  (state) => state.isEditing
);

export const selectStoreForm = createSelector(
  selectStoreState,
  (state) => state.storeForm
);

export const selectStoreId = createSelector(
  selectStoreState,
  (state) => state.storeId
);

export const selectStore = createSelector(
  selectStoreState,
  (state) => state.store
);

export const selectStoreListDropdowns = createSelector(
  selectStoreState,
  (state) => state.storeListDropdowns
);
